import dayjs from "dayjs";

// stats types
export const last5StatType = "last5";
export const seasonStatType = "season";
export const headToHeadStatType = "h2h";
export const homeAwayStatType = "homeaway";

// sort by types
export const statsSortByDescType = "stats-desc";
export const statsSortByAscType = "stats-asc";
export const oddsSortByDescType = "odds-desc";
export const oddsSortByAscType = "odds-asc";
export const kickoffSortByType = "kickoff";

// views
export const MARKETS_VIEW = "markets";
export const ODDS_VIEW = "odds";
export const STATS_VIEW = "stats";
export const DATE_VIEW = "date";
export const FIXTURES_VIEW = "fixtures";
export const SORT_BY_VIEW = "sortBy";
export const FAVOURITES_VIEW = "favourites";
export const COMBINED_FILTERS_VIEW = "combinedFilters";

export const StatsDropdownOptionsMap = new Map([
  [last5StatType, "Last 5 Matches"],
  [seasonStatType, "Season"],
  [headToHeadStatType, "Head To Head"],
  [homeAwayStatType, "Home / Away"],
]);

export const StatsDropdownOptionsSortOrder = [
  last5StatType,
  seasonStatType,
  headToHeadStatType,
  homeAwayStatType,
];

export const ViewOptions = ["date", "stats", "sortBy"];

export const SortByDropdownOptions = [
  statsSortByDescType,
  statsSortByAscType,
  oddsSortByDescType,
  oddsSortByAscType,
  kickoffSortByType,
];

export const SortByNameMap = new Map([
  [kickoffSortByType, "Kickoff Time"],
  [statsSortByDescType, "High % First"],
  [statsSortByAscType, "Low % First"],
  [oddsSortByDescType, "High Odds First"],
  [oddsSortByAscType, "Low Odds First"],
]);

export const SelectionDescriptionMap = new Map([
  [last5StatType, "% of times it occurred in the last 5 matches"],
  [seasonStatType, "% of times it occurred in this season"],
  [
    headToHeadStatType,
    "% of times it occurred between two sides since 2016/17",
  ],
  [homeAwayStatType, "% of times it occurred at Home / Away this season"],
  ["today", "Only show matches from today"],
  ["tomorrow", "Only show matches from tomorrow"],
  [statsSortByDescType, "Sort by highest - lowest percentage"],
  [statsSortByAscType, "Sort by lowest - highest percentage"],
  [oddsSortByDescType, "Sort by highest - lowest odds"],
  [oddsSortByAscType, "Sort by lowest - highest odds"],
  [kickoffSortByType, "Sort by kickoff time"],
]);

export const FilterHeaderNameMap = new Map([
  [ODDS_VIEW, "Odds"],
  [STATS_VIEW, "Calculate stats from..."],
  [DATE_VIEW, "Date"],
  [FIXTURES_VIEW, "Fixtures"],
  [SORT_BY_VIEW, "Sort By"],
  [MARKETS_VIEW, "Markets"],
  [FAVOURITES_VIEW, "Favourites"],
  [COMBINED_FILTERS_VIEW, "Filters"],
]);

export const favouritesSupportedViews = [MARKETS_VIEW, ODDS_VIEW];

export const CHANGE_NAME_VIEW = "change_name";
export const UPDATE_FAVOURITES_VIEW = "update_favourites";
export const ADD_FAVOURITES_VIEW = "add_favourites";
export const EDIT_FAVOURITES_VIEW = "edit_favourites";
export const MY_FAVOURITES_VIEW = "my_favourites";
export const WARNING_VIEW = "warning";

export const SubHeaderDescriptionMap = new Map([
  [last5StatType, "in the last 5 matches"],
  [seasonStatType, "this season"],
  [headToHeadStatType, "in the head to head matches since 2016/17"],
  [homeAwayStatType, "in the home/away matches"],
]);

export const canSelectMultipleFilters = [
  ODDS_VIEW,
  DATE_VIEW,
  FIXTURES_VIEW,
  MARKETS_VIEW,
];

export const FilterPillMap = new Map([
  ["Odds", "odds"],
  ["Date", "date"],
  ["Fixtures", "fixtures"],
  ["Markets", "markets"],
]);

export const DateTextMap = new Map([
  [dayjs().format("YYYY-MM-DD"), "Today"],
  [dayjs().add(1, "day").format("YYYY-MM-DD"), "Tomorrow"],
]);

export const SelectionMarketNameMap = new Map([
  ["1x2", "Match Odds"],
  ["BTTS", "Both Teams to Score?"],
  ["BTTSBH", "Both Teams To Score in Both Halves"],
  ["1x2BTTS", "Result & Both to Score"],
  ["1x2OU25", "Match Odds and Over/Under 2.5 Goals"],
  ["1x2OU35", "Match Odds and Over/Under 3.5 Goals"],
  ["OU15", "Over/Under 1.5 Goals"],
  ["OU25", "Over/Under 2.5 Goals"],
  ["OU35", "Over/Under 3.5 Goals"],
  ["OU45", "Over/Under 4.5 Goals"],
  ["TCOU85", "Corners Over/Under 8.5"],
  ["TCOU95", "Corners Over/Under 9.5"],
  ["TCOU105", "Corners Over/Under 10.5"],
  ["TCOU115", "Corners Over/Under 11.5"],
  ["P1+SOT", "Player To Have 1 Or More Shots On Target"],
  ["P2+SOT", "Player To Have 2 Or More Shots On Target"],
  ["P3+SOT", "Player To Have 3 Or More Shots On Target"],
  ["P1+SHOTS", "Player To Have 1 Or More Shots"],
  ["P2+SHOTS", "Player To Have 2 Or More Shots"],
  ["P3+SHOTS", "Player To Have 3 Or More Shots"],
  ["P1+FOULS", "Player To Commit 1 Or More Fouls"],
  ["P2+FOULS", "Player To Commit 2 Or More Fouls"],
  ["P3+FOULS", "Player To Commit 3 Or More Fouls"],
  ["AGS", "Anytime Goalscorer"],
  ["FGS", "First Goalscorer"],
  ["PTBC", "Player Shown a Card"],
  ["FPTBC", "First Player To Be Carded"],
  ["ACAOU25", "Home Team Total Cards 2.5"],
  ["ACAOU35", "Home Team Total Cards 3.5"],
  ["HCAOU25", "Away Team Total Cards 2.5"],
  ["HCAOU35", "Away Team Total Cards 3.5"],
  ["P1+FOULSWON", "Player To Be Fouled 1 Or More Times"],
  ["P2+FOULSWON", "Player To Be Fouled 2 Or More Times"],
  ["P3+FOULSWON", "Player To Be Fouled 3 Or More Times"],
  ["P4+FOULSWON", "Player To Be Fouled 4 Or More Times"],
  ["TCAOU25", "Cards Over/Under 2.5"],
  ["TCAOU35", "Cards Over/Under 3.5"],
  ["TCAOU45", "Cards Over/Under 4.5"],
  ["TCAOU55", "Cards Over/Under 5.5"],
  // TODO: Add More Markets/Updated text where necessary
]);

export const AnalyticsTypeMap = new Map([
  ["odds", "Odds"],
  ["stats", "Stats"],
  ["date", "Date"],
  ["sortBy", "Sort By"],
  ["fixtures", "Fixtures"],
  ["markets", "Markets"],
  [COMBINED_FILTERS_VIEW, "Filters"],
]);

export const PagingLimit = 50;

export const StatsPanelMatchSelectionMessageMap = new Map([
  [last5StatType, "in each of the teams' last 5 matches"],
  [seasonStatType, "for both teams this season"],
  [headToHeadStatType, "between the two teams since 2016/17"],
  [homeAwayStatType, "for both teams when playing at home/away this season"],
]);

export const StatsPanelSingleTeamMatchSelectionMessageMap = new Map([
  [last5StatType, "team's last 5 matches"],
  [seasonStatType, "team this season"],
  [headToHeadStatType, "team between the two teams since 2016/17"],
  [homeAwayStatType, "team when playing at home/away this season"],
]);

export const OversMarkets = [
  "OU15",
  "OU25",
  "OU35",
  "OU45",
  "TCOU85",
  "TCOU95",
  "TCOU105",
  "TCOU115",
  "HCAOU25",
  "HCAOU35",
  "ACAOU25",
  "ACAOU35",
  "TCAOU25",
  "TCAOU35",
  "TCAOU45",
  "TCAOU55",
];

export const ResultsMarkets = ["1x2", "1x2BTTS", "1x2OU25", "1x2OU35"];

export const OnboardingSteps = [
  {
    step: 1,
    title: "Pick your winning formula",
    description:
      "Select how to crunch those historical stats and spot the top picks in the market",
  },
  {
    step: 2,
    title: "Find your match day",
    description:
      "Zoom in on the fixtures and markets that get your betting buzz going",
  },
  {
    step: 3,
    title: "Your betting hotspot",
    description:
      "Where all the magic unfolds. Top selections, all lined up and ready to go",
  },
  {
    step: 4,
    title: "Stats at your fingertips",
    description:
      "We’ve done the heavy lifting. Check out the success rates of your selections, based on past form",
  },
  {
    step: 5,
    title: "Dive deeper into the past form",
    description:
      "A simple tap and you’ve got all the insights you need to make that savvy bet",
  },
  {
    step: 6,
    title: "Sort it your way",
    description:
      "...by odds, form, kickoff time – arrange your selections to suit your style and find your best bets fast",
  },
  {
    step: 7,
    title: "Bet Shuffle",
    description:
      "Stuck for choices? Let our clever algo whip up some bets for you. Don't like 'em? Give 'em a shuffle",
  },
];

export const ToolTipClassNameMap = new Map([
  [1, "toolTip--selectionsHeader"],
  [2, "toolTip--filterButtons"],
  [3, "toolTip--selectionRow"],
  [4, "toolTip--selectionRowStats"],
  [5, "toolTip--selectionRowForm"],
  [6, "toolTip--sortFilter"],
  [7, "toolTip--betShuffle"],
]);

export const SelectionsContainerClassNameMap = new Map([
  [3, "selectionsContainer--highlighted"],
  [4, "selectionsContainer--statsHighlighted"],
  [5, "selectionsContainer--formHighlighted"],
]);

export const fractionalOddsValuesMap = new Map([
  [0, "Min"],
  [1, "1/50"], // 1.02
  [2, "1/25"], // 1.04
  [3, "1/10"], // 1.1
  [4, "2/15"], // 1.13
  [5, "1/5"], // 1.2
  [6, "1/3"], // 1.33
  [7, "1/2"], // 1.5
  [8, "4/6"], // 1.67
  [9, "1/1"], // 2.0
  [10, "6/4"], // 2.5
  [11, "2/1"], // 3.0
  [12, "7/2"], // 4.5
  [13, "5/1"], // 6.0
  [14, "15/2"], //  8.5
  [15, "10/1"], // 11.0
  [16, "15/1"], // 16.0
  [17, "25/1"], // 26.0
  [18, "50/1"], // 51.0
  [19, "Max"],
]);

export const decimalOddsValuesMap = new Map([
  [0, "Min"],
  [1, 1.02], // 1/50
  [2, 1.04], // 1/25
  [3, 1.1], // 1/10
  [4, 1.13], // 2/15
  [5, 1.2], // 1/5
  [6, 1.33], // 1/3
  [7, 1.5], // 1/2
  [8, 1.67], // 4/6
  [9, 2.0], // 1/1
  [10, 2.5], // 6/4
  [11, 3.0], // 2/1
  [12, 4.5], // 7/2
  [13, 6.0], // 5/1
  [14, 8.5], //  15/2
  [15, 11.0], // 10/1
  [16, 16.0], // 15/1
  [17, 26.0], // 25/1
  [18, 51.0], // 50/1
  [19, "Max"],
]);

export const decimalValueToFractionalLabelMap = new Map([
  [0, "Min"],
  [1.02, "1/50"],
  [1.04, "1/25"],
  [1.1, "1/10"],
  [1.13, "2/15"],
  [1.2, "1/5"],
  [1.33, "1/3"],
  [1.5, "1/2"],
  [1.67, "4/6"],
  [2.0, "1/1"],
  [2.5, "6/4"],
  [3.0, "2/1"],
  [4.5, "7/2"],
  [6.0, "5/1"],
  [8.5, "15/2"],
  [11.0, "10/1"],
  [16.0, "15/1"],
  [26.0, "25/1"],
  [51.0, "50/1"],
  [Infinity, "Max"],
]);

export const decimalValueToDecimalLabelMap = new Map([
  [0, "Min"],
  [1.02, "1.02"],
  [1.04, "1.04"],
  [1.1, "1.1"],
  [1.13, "1.13"],
  [1.2, "1.2"],
  [1.33, "1.33"],
  [1.5, "1.5"],
  [1.67, "1.67"],
  [2.0, "2.0"],
  [2.5, "2.5"],
  [3.0, "3.0"],
  [4.5, "4.5"],
  [6.0, "6.0"],
  [8.5, "8.5"],
  [11.0, "11.0"],
  [16.0, "16.0"],
  [26.0, "26.0"],
  [51.0, "51.0"],
  [Infinity, "Max"],
]);

export const labelMaps = {
  decimal: decimalValueToDecimalLabelMap,
  fractional: decimalValueToFractionalLabelMap,
};

export const ODDS_FILTER_OPTIONS = [
  {
    minOdds: null,
    maxOdds: 1.53,
    fractional: {
      label: "Up to 8/15",
    },
    decimal: {
      label: "Up to 1.53",
    },
  },
  {
    minOdds: 1.5,
    maxOdds: 1.73,
    fractional: {
      label: "1/2 to 8/11",
    },
    decimal: {
      label: "1.5 to 1.73",
    },
  },
  {
    minOdds: 1.8,
    maxOdds: 2.88,
    fractional: {
      label: "4/5 to 15/8",
    },
    decimal: {
      label: "1.8 to 2.88",
    },
  },
  {
    minOdds: 3.0,
    maxOdds: Infinity,
    fractional: {
      label: "2/1 +",
    },
    decimal: {
      label: "3.0 +",
    },
  },
];

export const ODDS_FILTER_FRACTIONAL_LABELS = new Map([
  [0, "Min"],
  [1.02, "1/50"],
  [1.04, "1/25"],
  [1.1, "1/10"],
  [1.13, "2/15"],
  [1.2, "1/5"],
  [1.33, "1/3"],
  [1.5, "1/2"],
  [1.53, "8/15"],
  [1.67, "4/6"],
  [1.73, "8/11"],
  [1.8, "4/5"],
  [2.0, "1/1"],
  [2.5, "6/4"],
  [2.88, "15/8"],
  [3.0, "2/1"],
  [4.5, "7/2"],
  [6.0, "5/1"],
  [8.5, "15/2"],
  [11.0, "10/1"],
  [16.0, "15/1"],
  [26.0, "25/1"],
  [51.0, "50/1"],
  [Infinity, "2/1 +"],
]);
export const ODDS_FILTER_DECIMAL_LABELS = new Map([
  [0, "Min"],
  [1.02, "1.02"],
  [1.04, "1.04"],
  [1.1, "1.1"],
  [1.13, "1.13"],
  [1.2, "1.2"],
  [1.33, "1.33"],
  [1.5, "1.5"],
  [1.53, "1.53"],
  [1.67, "1.67"],
  [1.73, "1.73"],
  [1.8, "1.8"],
  [2.0, "2.0"],
  [2.5, "2.5"],
  [2.88, "2.88"],
  [3.0, "3.0"],
  [4.5, "4.5"],
  [6.0, "6.0"],
  [8.5, "8.5"],
  [11.0, "11.0"],
  [16.0, "16.0"],
  [26.0, "26.0"],
  [51.0, "51.0"],
  [Infinity, "3.0 +"],
]);

export const ODDS_FILTER_LABELS = {
  fractional: ODDS_FILTER_FRACTIONAL_LABELS,
  decimal: ODDS_FILTER_DECIMAL_LABELS,
};

export const DEBOUNCE_TIMER = 250;

export const LOCATION_MAP = new Map([
  ["", "selections"],
  ["betShuffle", "shuffle"],
]);

export const FAVOURITES_LIMIT = 10;
